import { WS_CON_STATE_RECONNECTING, WS_CON_STATE_DISCONNECTED, WS_CON_STATE_CONNECTED } from "./WebSocketsHook";
export const getWebSocketStatusColor = ({
  showStatus = true,
  wsStatus
}) => {
  if (showStatus) {
    switch (wsStatus) {
      case WS_CON_STATE_DISCONNECTED:
        return "red";
      case WS_CON_STATE_RECONNECTING:
        return "orange";
      case WS_CON_STATE_CONNECTED:
        return "green";
      default:
        return null;
    }
  }
  return null;
};